<template>
    <div class="hos-form">
        <div class="sub_title cb"><img src="../../assets/icon/Rectangle2.png" class="mr10 imgb">开放预约科室</div>
        <div class="dateHeader mt20 flex fs14">
            <div class="left"></div>
            <div class="right flex">
                <div class="dateCol"></div>
                <div class="dateCol flex aic jcc" v-for="(date,index) in dateArr" :key="index">
                    <div>
                        <p>{{date.date}}</p>
                        <p>{{date.week}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="docBody flex borderTopNone" v-for="(schedule,index) in list" :key="index" :class="[index != 0 ? ['mt20','borderShow'] : '']">
            <div class="left flex">
                <div class="docIcon flex aic jcc">
                    <img :src="docAva"/>
                </div>
                <div class="docInfo flex aic">
                    <div>
                        <p class="docName">{{schedule.docName}}<span class="ml20">{{schedule.title}}</span></p>
                        <p class="docSkill">{{schedule.skill}}</p>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="numRow flex">
                    <div class="numCol flex aic jcc" style="font-family:PingFangSC-Regular;font-size: 16px;color: #333333;">上午</div>
                    <div class="numCol flex aic jcc pointer" v-for="(m,index) in schedule.pbList[0].list" :key="index" @click="saveSche(m)">
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '0'" style="color: #666666;">预约</span>
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '1'" style="color: #F9A036;">停诊</span>
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '2'">已结束</span>
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '3'" style="color: #FF0000;">已满</span>
                        <span v-show="m.hyinfo.length <= 0"></span>
                    </div>
                </div>
                <div class="numRow flex">
                    <div class="numCol flex aic jcc" style="font-family:PingFangSC-Regular;font-size: 16px;color: #333333;">下午</div>
                    <div class="numCol flex aic jcc pointer" v-for="(m,index) in schedule.pbList[1].list" :key="index" @click="saveSche(m)">
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '0'" style="color: #666666;">预约</span>
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '1'" style="color: #F9A036;">停诊</span>
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '2'">已结束</span>
                        <span v-show="m.hyinfo.length > 0 && m.hyinfo[0].schstate == '3'" style="color: #FF0000;">已满</span>
                        <span v-show="m.hyinfo.length <= 0"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {orderTime} from "../../lib/cache/OrderTime";


  export default {
    name: "scheduleList",
    props: {
      list: {
        type: Array,
        default: ()=>{
          return []
        }
      },
      dateArr: {
        type: Array,
        default: ()=>{
          return []
        }
      },
    },
    data() {
      return {
        id: '1',
        left:0,
          right:7,
          docAva:require('../../assets/docAva.png')
      }
    },
    watch: {
      id(newV) {
        this.$emit('input', newV);
      }
    },
    mounted(){
    },
    methods:{
      saveSche(item){
          const ot = orderTime.get()
          console.log(item)
          ot.schid = item.hyinfo[0].schid
          ot.docid = item.hyinfo[0].docid //医生id
          ot.schdate = item.hyinfo[0].schdate
          ot.ampm = item.hyinfo[0].ampm
          ot.week = item.week
          ot.regfee = item.hyinfo[0].regfee
          ot.docName = item.hyinfo[0].docname==''?'普通号':item.hyinfo[0].docname
          orderTime.set(ot)
          this.$router.push('/main/registration/num')
      }
    }
  }
</script>

<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .hos-form{
        padding: 10px 20px;
        color: #666666;
        span+span{
            margin-right: 10px;
            cursor: pointer;
        }
    }
    .cb{
        font-weight: bold;
        color: #333333;
    }
    .sub_title{
        padding: 5px 0;
    }
    .imgb{
        vertical-align: bottom;
    }

    .dateHeader{
        height: 70px;
        border: 1px solid #E8E8E8;
        border-radius: 1px;
    }
    .docBody{
        height: 90px;
    }

    .left{
        flex:3;
        border-right:1px solid #E8E8E8;
        .docIcon{
            flex:4;
            img{
                width: 80%;
                height: 80%;
                border-radius: 50%;
            }
        }
        .docInfo{
            flex:6;
            justify-content: flex-start;
            font-family: PingFangSC-Regular;
            .docName{
                font-size: 16px;
                color: #333333;
            }
            .docSkill{
                font-size: 14px;
                color: #666666;
                overflow: hidden;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
            }
        }
    }
    .right{
        flex:7;
        .dateCol{
            flex:1;
            font-family: PingFangSC-Medium;
            color: #333333;
        }
        .numRow{
            height: 50%;
            .numCol{
                flex: 1;
                font-family: PingFangSC-Regular;
                color: #666666;
            }
        }
    }

    .borderShow{
        border: 1px solid #E8E8E8;
        border-radius: 1px;
    }

    .borderTopNone{
        border-left: 1px solid #E8E8E8;
        border-right: 1px solid #E8E8E8;
        border-bottom: 1px solid #E8E8E8;
    }
</style>
